import { Navigate, useParams } from 'react-router';
import { ProtectedRoute } from '../components/ProtectedRoute';
import { useApp } from '../providers/AppProvider';
import TaskDetail from './TaskDetail';

function ProtectedTaskDetailContent() {
  const { taskId } = useParams<{ taskId: string }>();
  const { state, loading } = useApp();

  const task = state?.tasks.find((item) => item.id === taskId);

  if (!loading && task?.projectId) {
    return <Navigate to={`/app/projects/${task.projectId}/task/${task.id}`} replace />;
  }

  return <TaskDetail />;
}

export default function ProtectedTaskDetail() {
  return (
    <ProtectedRoute>
      <ProtectedTaskDetailContent />
    </ProtectedRoute>
  );
}
